const formatCardNumber = (cardNumber) => (cardNumber.match(/.{1,4}/g) || []).join(' ');

export default formatCardNumber;
